'use client'
import { useContextElement } from '@/context/Context'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Option1 from '../singleProduct/Option1'
import Option2 from '../singleProduct/Option2'
import Size from '../singleProduct/Size'
import Colors from '../singleProduct/Colors'
import Image from 'next/image'
import ShareComponent from '../common/ShareComponent'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'

export default function QuickView() {
  const {
    quickViewItem,
    toggleWishlist,
    isAddedtoWishlist,
    cartProducts,
    addProductToCart,
  } = useContextElement()
  const [selectedProductOption, setSelectedProductOption] = useState(null)
  const [skuName1, setSkuName1] = useState('')
  const [skuName2, setSkuName2] = useState('')

  const swiperOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    effect: 'none',
    modules: [Navigation],
    loop: false,
    navigation: {
      nextEl:
        '.modal-dialog.quick-view .product-single__media .swiper-button-next',
      prevEl:
        '.modal-dialog.quick-view .product-single__media .swiper-button-prev',
    },
  }

  const [quantity, setQuantity] = useState(1)
  const [maxQuantity, setMaxQuantity] = useState(999)

  // 價錢預設顯示商品頁的價格 如果有選項會依照選項改變價格
  const [price, setPrice] = useState(99999)
  const [salePrice, setSalePrice] = useState(99999)
  const [swiperSlideItems, setSwiperSlideItems] = useState([])

  //檢查品項是否已在購物車
  const isIncludeCard = () => {
    if (quickViewItem.IsProductOption1 || quickViewItem.IsProductOption2) {
      const item = cartProducts.filter(
        (elm) =>
          elm.ProductID == quickViewItem.ProductID &&
          elm.ProductOption[0].GoodID == selectedProductOption.GoodID
      )[0]
      return item
    } else {
      const item = cartProducts.filter(
        (elm) =>
          elm.ProductID == quickViewItem.ProductID &&
          elm.ProductOption[0].GoodID == quickViewItem.ProductOption[0].GoodID
      )[0]
      return item
    }
  }

  const setQuantityCartItem = (qty) => {
    const q = Math.max(1, Math.min(qty, maxQuantity))
    setQuantity(q)
  }

  const addToCart = () => {
    if (
      (quickViewItem.IsProductOption1 || quickViewItem.IsProductOption2) &&
      !selectedProductOption?.SkuID
    ) {
      toast.warning('請選擇完整的商品選項')
      return
    }

    const item = {
      ProductID: quickViewItem.ProductID,
      ProductName: quickViewItem.ProductName,
      Qty: quantity,
      SuggestPrice:
        selectedProductOption?.SuggestPrice ?? quickViewItem.SuggestPrice,
      Price: selectedProductOption?.Price ?? quickViewItem.Price,
      Cost: quickViewItem.Cost,
      PriceFromProduct: quickViewItem.Price,
      PictureData: quickViewItem.PictureData,
      SkuID: selectedProductOption?.SkuID,
      SkuName: selectedProductOption?.SkuName,
      Status: quickViewItem.Status,
      InventoryQty:
        selectedProductOption?.InventoryQty ?? quickViewItem.InventoryQty,
      LimitedQty: selectedProductOption?.LimitedQty ?? quickViewItem.LimitedQty,
    }

    addProductToCart(item)
    toast.success('已加入購物車')
  }

  useEffect(() => {
    setPrice(quickViewItem.SuggestPrice ?? 99999)
    setSalePrice(quickViewItem.Price ?? 99999)
    setMaxQuantity(
      Math.min(
        quickViewItem.InventoryQty ?? 999,
        quickViewItem.LimitedQty ?? 999
      )
    )
    setSwiperSlideItems(
      quickViewItem.PictureData?.map((item) => item.Name) || []
    )
  }, [])
  useEffect(() => {
    setPrice(quickViewItem.SuggestPrice ?? 99999)
    setSalePrice(quickViewItem.Price ?? 99999)
    setMaxQuantity(
      Math.min(
        quickViewItem.InventoryQty ?? 999,
        quickViewItem.LimitedQty ?? 999
      )
    )
    setSwiperSlideItems(
      quickViewItem.PictureData?.map((item) => item.Name) || []
    )

    let skuName = ''
    if (quickViewItem?.IsProductOption1) skuName += skuName1
    if (quickViewItem?.IsProductOption2) {
      if (skuName !== '') skuName += '/'
      skuName += skuName2
    }

    const productOption = quickViewItem?.ProductOption?.find(
      (elm) => elm.SkuName === skuName
    )

    if (productOption) {
      setPrice(productOption.SuggestPrice)
      setSalePrice(productOption.Price)
    }

    setSelectedProductOption(productOption)
  }, [skuName1, skuName2, quickViewItem])

  if (quickViewItem == null) {
    return (
      <div className="modal fade" id="quickView" tabIndex="-1">
        <div className="modal-dialog quick-view modal-dialog-centered">
          <div className="modal-content">
            <div className="p-4 text-center">Loading...</div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="modal fade" id="quickView" tabIndex="-1">
        <div className="modal-dialog quick-view modal-dialog-centered">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="product-single">
              <div className="product-single__media m-0">
                <div className="product-single__image position-relative w-100">
                  <Swiper
                    {...swiperOptions}
                    className="swiper-container js-swiper-slider"
                  >
                    {swiperSlideItems.map((elm, i) => (
                      <SwiperSlide
                        key={i}
                        className="swiper-slide product-single__image-item"
                      >
                        <Image
                          loading="lazy"
                          width={500}
                          height={700}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                          src={elm}
                          alt="image"
                        />
                      </SwiperSlide>
                    ))}

                    <div className="cursor-pointer swiper-button-prev">
                      <svg
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <use href="#icon_prev_sm" />
                      </svg>
                    </div>
                    <div className="cursor-pointer swiper-button-next">
                      <svg
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <use href="#icon_next_sm" />
                      </svg>
                    </div>
                  </Swiper>
                </div>
              </div>
              <div className="product-single__detail">
                <h1 className="product-single__name">
                  {quickViewItem.ProductName}
                </h1>
                <div className="product-single__price">
                  {salePrice < price ? (
                    <>
                      {' '}
                      <span className="money price price-old"> ${price}</span>
                      <span className="money price-sale current-price">
                        ${salePrice}
                      </span>
                    </>
                  ) : (
                    <span className="money current-price">${price}</span>
                  )}
                </div>
                <div className="product-single__short-desc">
                  <p>
                    {/* Phasellus sed volutpat orci. Fusce eget lore mauris vehicula
                  elementum gravida nec dui. Aenean aliquam varius ipsum, non
                  ultricies tellus sodales eu. Donec dignissim viverra nunc, ut
                  aliquet magna posuere eget. */}
                  </p>
                </div>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="product-single__swatches">
                    {quickViewItem.IsProductOption1 ? (
                      quickViewItem.ProductOption1.OptionType == '1' ? (
                        <div className="product-swatch text-swatches">
                          <label>{quickViewItem.ProductOption1.Name}</label>
                          <div className="swatch-list">
                            <Option1
                              ProductID={quickViewItem.ProductID}
                              Data={quickViewItem.ProductOption1.Data}
                              onChange={(val) => {
                                setSkuName1(val)
                              }}
                            />
                          </div>
                          {/* <a href="#" className="sizeguide-link" data-bs-toggle="modal" data-bs-target="#sizeGuide" > Size Guide </a> */}
                        </div>
                      ) : (
                        //  暫時沒有 Color
                        <div className="product-swatch color-swatches">
                          <label>Color</label>
                          <div className="swatch-list">
                            <Colors />
                          </div>
                        </div>
                      )
                    ) : (
                      <></>
                    )}

                    {quickViewItem.IsProductOption2 ? (
                      quickViewItem.ProductOption2.OptionType == '1' ? (
                        <div className="product-swatch text-swatches">
                          <label>{quickViewItem.ProductOption2.Name}</label>
                          <div className="swatch-list">
                            <Option2
                              ProductID={quickViewItem.ProductID}
                              Data={quickViewItem.ProductOption2.Data}
                              onChange={(val) => {
                                setSkuName2(val)
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="product-swatch color-swatches">
                          <label>Color</label>
                          <div className="swatch-list">
                            <Colors />
                          </div>
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="product-single__addtocart">
                    <div className="qty-control position-relative">
                      <input
                        type="number"
                        name="quantity"
                        value={quantity}
                        readOnly
                        min="1"
                        max={`${maxQuantity}`}
                        onChange={(e) =>
                          setQuantityCartItem(Number(e.target.value))
                        }
                        className="qty-control__number text-center"
                      />
                      <div
                        onClick={() => setQuantityCartItem(quantity - 1)}
                        className="qty-control__reduce"
                      >
                        -
                      </div>
                      <div
                        onClick={() => setQuantityCartItem(quantity + 1)}
                        className="qty-control__increase"
                      >
                        +
                      </div>
                    </div>

                    <button
                      onClick={() => addToCart()}
                      // disabled={
                      //   (quickViewItem.IsProductOption1 ||
                      //     quickViewItem.IsProductOption2) &&
                      //   !selectedProductOption?.SkuID
                      // }
                      className={`btn btn-primary btn-addtocart js-open-aside ${(quickViewItem.IsProductOption1 || quickViewItem.IsProductOption2) && !selectedProductOption?.SkuID ? 'disabled' : 'enable'}`}
                    >
                      {
                        /* {isAddedToCartProducts(quickViewItem.ProductID)
                      ? '已加入購物車'
                      : '加入購物車'} */ '加入購物車'
                      }
                    </button>
                  </div>
                </form>
                <div className="product-single__addtolinks">
                  <a
                    href="#"
                    className={`menu-link menu-link_us-s add-to-wishlist  ${
                      isAddedtoWishlist(quickViewItem.ProductID) ? 'active' : ''
                    }`}
                    onClick={() => toggleWishlist(quickViewItem.ProductID)}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <use href="#icon_heart" />
                    </svg>
                    <span>加入願望清單</span>
                  </a>
                  <ShareComponent title={quickViewItem.ProductName} />
                </div>
                <div className="product-single__meta-info mb-0">
                  <div className="meta-item">
                    <label>SKU:</label>
                    <span>{selectedProductOption?.SkuID}</span>
                  </div>
                  <div className="meta-item">
                    <label>Categories:</label>
                    <span>Casual & Urban Wear, Jackets, Men</span>
                  </div>
                  <div className="meta-item">
                    <label>Tags:</label>
                    <span>biker, black, bomber, leather</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
